import { defineMessages } from 'react-intl';

export const scope = 'app.components.FormFactorChooser';

export default defineMessages({
  mobilePreview: {
    id: `${scope}.mobilePreview`,
    defaultMessage: 'Mobile preview',
  },
  desktopPreview: {
    id: `${scope}.desktopPreview`,
    defaultMessage: 'Desktop preview',
  },
});
